// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"138":"a6cd545cbca22ff1","185":"e772c9745ffc5b22"}[chunkId] + ".css";
};